export default __webpack_public_path__ + "static/media/27-min.cb31fe2e.png";